export default __webpack_public_path__ + "static/media/669.a9981a25.gif";